var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detail-header',{attrs:{"show-toggle":false,"show-new":false,"show-print":false,"show-delete":false,"show-save":false,"show-cancel":true},on:{"appDetailHeaderButtonClicked":_vm.onHeaderButtonClicked}}),(_vm.callLog)?_c('router-view',{attrs:{"value":_vm.callLog.vehicleData,"options":_vm.options}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }